import PropTypes from 'prop-types';

import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import SportsKabaddiIcon from '@mui/icons-material/SportsKabaddi';
import Stack from '@mui/material/Stack';

import BlankContent from '../common/BlankContent';
import LeadCard from './LeadCard';
import LeadTableRow from './LeadTableRow';
// import SessionListItem from './SessionListItem';
import CustomPagination from "../common/CustomPagination";

const columns = [
  {
    label: '',
    key: 'has_updates',
    align: 'center',
  },
  {
    label: 'Status',
    key: 'status',
    align: 'left',
  },
  {
    label: 'Name',
    key: 'contact_name',
    align: 'left',
  },
  {
    label: 'Provider',
    key: 'provider',
    align: 'left',
  },
  {
    label: 'Referrer Name',
    key: 'referral_name',
    align: 'left',
  },
  {
    label: 'Email',
    key: 'contact_email',
    align: 'left',
  },
  {
    label: 'Phone',
    key: 'contact_phone',
    align: 'center',
  },
  {
    label: 'Date Created',
    key: 'date_created',
    align: 'center',
    sort: 'date_created',
  },
  {
    label: '',
    key: 'actions',
    align: 'right',
  },
];

const LeadTable = props => {
  const isEmpty = !props.rows || !props.rows.length;
  return (
    <>
      <Paper 
        sx={{ width: '100%', display: {xs: 'none', sm: 'block'}}} 
        elevation={0}
      >
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{'th': {paddingBottom: '6px'}}}>
                {
                  columns.map(col => 
                    <TableCell align={col.align}>
                      {col.label}
                      {props?.filters?.sort === col.key 
                       ? <ArrowUpwardIcon sx={{fontSize: '0.75rem', marginLeft: '0.25rem'}} />
                       : null
                      }
                      {
                        props?.filters?.sort === `-${col.key}`
                        ? <ArrowDownwardIcon sx={{fontSize: '0.75rem', marginLeft: '0.25rem'}} />
                        : null
                      }
                    </TableCell>
                  )
                }
              </TableRow>
            </TableHead>
            <TableBody>
              {(props.rows|| []).map(row =>
                <LeadTableRow
                  row={row}
                  // afterSave={() => {
                  //   props.afterSave();
                  // }}
                />
              )}
            </TableBody>
          </Table>
          {
            isEmpty
            ? <BlankContent
              title='No leads found'
              Icon={SportsKabaddiIcon}
            />
            : null
          }
        </TableContainer>
        {
          !isEmpty &&
          <Box sx={{marginTop: '0.625rem'}}>
            <CustomPagination
              pageSize={props.pageSize}
              pageIndex={props.pageIndex}
              count={props.count}
              onPageChange={(e,num) => props.onPageChange(e, num)}
            ></CustomPagination>
          </Box>
        }
      </Paper>
      {/* If screen size is xs then replace the table with a mobile-friendly list */}
      <Box 
        sx={{display: {'xs': 'block', 'sm': 'none', 'md': 'none', 'lg': 'none'}}}
        paddingBottom={4}
      >
        <Stack spacing={1} padding={1}>
          {(props.rows|| []).map(row =>
            <LeadCard lead={row.data} />
          )}
        </Stack>
        <Box style={{marginTop: '1em'}}>
          { props.rows && props.rows.length
            ? <Stack direction='row' justifyContent='center'>
                <CustomPagination
                  pageSize={props.pageSize}
                  pageIndex={props.pageIndex}
                  count={props.count}
                  onPageChange={props.onPageChange}
                ></CustomPagination>
            </Stack>
            : null
          }
        </Box>
        {
          isEmpty
          ? <BlankContent
            title='No leads found'
            Icon={SportsKabaddiIcon}
          />
          : null
        }
      </Box>
    </>
  );
};

LeadTable.defaultProps = {
};

LeadTable.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.shape({
    data: PropTypes.object, // data for the row
    buttons: PropTypes.arrayOf(PropTypes.element),
  })),
  count: PropTypes.number,
  pageIndex: PropTypes.number,
  pageSize: PropTypes.number,
  onPageChange: PropTypes.func,
  onRowsPerPageChange: PropTypes.func,
  afterSave: PropTypes.func,
};

export default LeadTable;
